import {html, LitElement} from "lit";
import {WlSelected} from "../events/WlSelected";
import {WlOption} from "../option/option.component";

export class WlMonoSelect extends LitElement {
    render() {
        return html`
            <slot @wl-selected="${this._maintainOneSelected}"></slot>
        `
    }

    _maintainOneSelected(event: WlSelected) {
        const slot = this.shadowRoot?.querySelector('slot');
        slot?.assignedElements({flatten: true})
            .filter((element) => element != event.target)
            .forEach((element) => (element as WlOption).uncheck());
    }

    clear() {
        const slot = this.shadowRoot?.querySelector('slot');
        slot?.assignedElements({flatten: true})
            .forEach((element) => (element as WlOption).uncheck());
    }
}